import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=56bbb634&"
import script from "./SocialMedia.vue?vue&type=script&lang=ts&"
export * from "./SocialMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports